export function logEvent(event, resource = null) {
  const params = new URLSearchParams({
    event,
    path: window.location.pathname,
  });

  resource && params.set('resource', resource);
  
  fetch(`/api/l?${params}`, {
    method: 'GET',
    keepalive: true,
  }).catch(() => {});
}
